import request from '@/utils/util.request';
/*
 *  (doodling) 小黑板页面
 */
export const doodling_load_data = (data) => {
	return request({
		url: '/doodling/loaddata',
		data,
	});
};

/*
 *  (doodling) 小黑板投屏
 */
export const doodling_project = (data) => {
	return request({
		url: '/doodling/project',
		data,
	});
};
